import { capitalize } from '@mui/material'
import React from 'react'
import { useMediaQuery } from 'react-responsive'
import PageContainer from '../components/PageContainer'
import { dataCatalogue } from '../util'

const Catalogues = () => {
    const md = useMediaQuery({ query: '(min-width: 1200px)' })
    
    return (
        <PageContainer>
            <section className="inner-banner parallax-section">
                <div className='overlay'>
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 col-sm-12">
                                <h3 className="wow bounceIn" data-wow-delay="0.9s">Data</h3>
                                <h1 className="wow fadeInUp text-uppercase conference mb-05 mt-05" data-wow-delay="1.6s">Catalogues</h1>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            
            {/* <!-- =========================
                OVERVIEW SECTION   
            ============================== --> */}
            <div className="services-area section-padding2">
                <div className="container">
                    <div className="row">
                        {
                            dataCatalogue.map((cat, key) => (
                                <div className="col-12" key={key}>
                                    <div className="row single-services text-center mb-30 align-items-center">
                                        <div className="col-12 col-lg-4 services-icon">
                                            {cat.icon}
                                            <h4>{capitalize(cat.title || '')}</h4>
                                        </div>
                                        <div className="row col-12 col-lg-8 services-caption">
                                            {
                                                cat.subCatalogues.map((subCat, index) => (
                                                    <div className='col-12 col-lg-6 text-left' key={index}>
                                                        <p>
                                                            {typeof(subCat) === 'string' ? subCat : subCat.title}
                                                            {
                                                                Boolean(subCat?.sub?.length > 0) && 
                                                                <ul>
                                                                    {subCat?.sub?.map((s, inx) => (
                                                                        <li key={inx}>{s}</li>
                                                                    ))}
                                                                </ul>
                                                            }
                                                        </p>
                                                    </div>
                                                ))
                                            }
                                        </div>
                                    </div>
                                </div>
                            ))
                        }
                    </div>
                </div>
            </div>

        </PageContainer>

    )
}

export default Catalogues